import { lazy } from 'react'
import {
  Workflow, Shield, ShieldCheck, FileText, BookText, Users, TrendingUp, List, Target,
  Sparkles, MessageSquare, MessageSquareDot, History,
} from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Automations = lazy(() => import('@/features/admin/pages/Automations').then((m) => ({ default: m.Automations })))
const AdminUsers = lazy(() => import('@/features/admin/pages/Users').then((m) => ({ default: m.AdminUsers })))
const AdminFields = lazy(() => import('@/features/admin/pages/Fields').then((m) => ({ default: m.AdminFields })))
const AdminStages = lazy(() => import('@/features/admin/pages/Stages').then((m) => ({ default: m.AdminStages })))
const AdminAudit = lazy(() => import('@/features/admin/pages/Audit').then((m) => ({ default: m.AdminAudit })))
const AdminAiUsage = lazy(() => import('@/features/admin/pages/AiUsage').then((m) => ({ default: m.AdminAiUsage })))
const AdminResponseBlocks = lazy(() => import('@/features/admin/pages/ResponseBlocks').then((m) => ({ default: m.AdminResponseBlocks })))
const AdminStaffProfiles = lazy(() => import('@/features/admin/pages/StaffProfiles').then((m) => ({ default: m.AdminStaffProfiles })))
const AdminLookups = lazy(() => import('@/features/admin/pages/Lookups').then((m) => ({ default: m.AdminLookups })))
const AdminGoals = lazy(() => import('@/features/admin/pages/Goals').then((m) => ({ default: m.AdminGoals })))
const AdminAiChats = lazy(() => import('@/features/admin/pages/AiChats').then((m) => ({ default: m.AdminAiChats })))
const AdminFeedback = lazy(() => import('@/features/admin/pages/Feedback').then((m) => ({ default: m.AdminFeedback })))
const AdminPermissions = lazy(() => import('@/features/admin/pages/Permissions').then((m) => ({ default: m.AdminPermissions })))

const admin = ['admin']

export const adminRoutes: FeatureRoute[] = [
  { path: 'automations', element: <Automations />, roles: admin },
  { path: 'admin/users', element: <AdminUsers />, roles: admin },
  { path: 'admin/permissions', element: <AdminPermissions />, roles: admin },
  { path: 'admin/fields', element: <AdminFields />, roles: admin },
  { path: 'admin/stages', element: <AdminStages />, roles: admin },
  { path: 'admin/audit', element: <AdminAudit />, roles: admin },
  { path: 'admin/ai-usage', element: <AdminAiUsage />, roles: admin },
  { path: 'admin/firm-info', element: <AdminResponseBlocks />, roles: admin },
  { path: 'admin/staff', element: <AdminStaffProfiles />, roles: admin },
  { path: 'admin/lookups', element: <AdminLookups />, roles: admin },
  { path: 'admin/goals', element: <AdminGoals />, roles: admin },
  { path: 'admin/ai-chats', element: <AdminAiChats />, roles: admin },
  { path: 'admin/feedback', element: <AdminFeedback />, roles: admin },
]

export const adminNav: NavItem[] = [
  { to: '/automations', label: 'Automations', icon: Workflow, section: 'Admin', adminOnly: true },
  { to: '/admin/users', label: 'Users', icon: Shield, section: 'Admin', adminOnly: true },
  { to: '/admin/permissions', label: 'Permissions', icon: ShieldCheck, section: 'Admin', adminOnly: true },
  { to: '/admin/fields', label: 'Custom fields', icon: FileText, section: 'Admin', adminOnly: true },
  { to: '/admin/firm-info', label: 'Firm info & RFP boilerplate', icon: BookText, section: 'Admin', adminOnly: true },
  { to: '/admin/staff', label: 'Staff profiles', icon: Users, section: 'Admin', adminOnly: true },
  { to: '/admin/stages', label: 'Stages', icon: TrendingUp, section: 'Admin', adminOnly: true },
  { to: '/admin/lookups', label: 'Lookup tables', icon: List, section: 'Admin', adminOnly: true },
  { to: '/admin/goals', label: 'Goals', icon: Target, section: 'Admin', adminOnly: true },
  { to: '/admin/ai-usage', label: 'AI usage', icon: Sparkles, section: 'Admin', adminOnly: true },
  { to: '/admin/ai-chats', label: 'AI chats', icon: MessageSquare, section: 'Admin', adminOnly: true },
  { to: '/admin/feedback', label: 'Feedback', icon: MessageSquareDot, section: 'Admin', adminOnly: true },
  { to: '/admin/audit', label: 'Audit log', icon: History, section: 'Admin', adminOnly: true },
]
